import * as React from 'react';

import { Box } from '@mui/material';
import TabsContentLogs, { TabsContentLogsBaseProps } from './TabsContentLogs';
import TabsContentMonitoring, { TabsContentMonitoringBaseProps } from './TabsContentMonitoring';
import TabsContentMetrics, { TabsContentMetricsBaseProps } from './TabsContentMetrics';


type TabsContentProps = TabsContentLogsBaseProps & TabsContentMetricsBaseProps & TabsContentMonitoringBaseProps & {
  tabId: number
}

const TabsContent = (props: TabsContentProps) => {

  const getIsVisible = React.useCallback((i: number) => {
    return i === props.tabId
  }, [props.tabId]);

  return <Box>
    <TabsContentLogs {...props} isVisible={getIsVisible(0)} />
    <TabsContentMetrics {...props} isVisible={getIsVisible(1)} />
    <TabsContentMonitoring {...props} isVisible={getIsVisible(2)} />
  </Box>
}

export default TabsContent;
